import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import UIFloatingFormControl from 'UIComponents/form/UIFloatingFormControl';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import UITruncateString from 'UIComponents/text/UITruncateString';
import PropertyRecord from '../records/PropertyRecord';
import TaxonomyInputUtils from '../utils/TaxonomyInputUtils';
import { FUNNEL_STAGE } from '../constants/ConversationsProperties';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledOption = styled.div.withConfig({
  displayName: "FunnelStageSelect__StyledOption",
  componentId: "sc-52bgyu-0"
})(["padding:8px 20px;"]);

// @ts-expect-error ts-migrate(2456) FIXME: Type alias 'Props' circularly references itself.

// @ts-expect-error ts-migrate(7022) FIXME: 'FunnelStageSelect' implicitly has type 'any' beca... Remove this comment to see the full error message
const FunnelStageSelect = ({
  allProperties,
  currentValue,
  onChange,
  displayMode,
  ghosted
}) => {
  const renderOption = option => {
    return /*#__PURE__*/_jsxs(StyledOption, {
      children: [/*#__PURE__*/_jsx("span", {
        children: option.text
      }), /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsx(UITruncateString, {
          children: option.help
        })
      })]
    });
  };
  const FormWrapper = displayMode === 'card' ? UIFloatingFormControl : UIFormControl;
  return (
    /*#__PURE__*/
    // @ts-expect-error ts-migrate(2604) FIXME: JSX element type 'FormWrapper' does not have any c... Remove this comment to see the full error message
    _jsx(FormWrapper, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.taxonomy.property.funnel.label"
      }),
      verticalSeparation: "flush",
      children: /*#__PURE__*/_jsx(UISelect, Object.assign({}, displayMode === 'panel' && {
        buttonUse: 'form'
      }, {
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        className: displayMode === 'card' ? 'p-left-0' : null,
        "data-test-id": "funnel-stage-select-input",
        menuWidth: displayMode === 'panel' ? 350 : 250,
        onChange: ({
          target: {
            value
          }
        }) => onChange(new PropertyRecord({
          // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'undefined... Remove this comment to see the full error message
          name: FUNNEL_STAGE,
          value,
          revisionCode: currentValue ? currentValue.revisionCode : 0
        })),
        optionRenderer: option => renderOption(option),
        options: TaxonomyInputUtils.mapPropertiesToOptions({
          properties: allProperties,
          propertyKey: 'funnel',
          showHelp: true
        }),
        placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.taxonomy.property.funnel.placeholder"
        }),
        readOnly: ghosted,
        value: currentValue ? currentValue.value : null
      }))
    })
  );
};
FunnelStageSelect.propTypes = {
  allProperties: ImmutablePropTypes.list.isRequired,
  currentValue: PropTypes.instanceOf(PropertyRecord),
  displayMode: PropTypes.string.isRequired,
  ghosted: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};
FunnelStageSelect.defaultProps = {
  currentValue: null,
  ghosted: false
};
export default FunnelStageSelect;